// src/app/components/revoke-token-modal/revoke-token-modal.component.ts
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-revoke-token-modal',
  templateUrl: './revoke-token-modal.component.html',
})
export class RevokeTokenModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  revoke(): void {
    this.activeModal.close('revoke');
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
